export const actionTypes = {
  SET_VSFP: "SET_VSFP",
  SET_VSFP_FILTERED: "SET_VSFP_FILTERED",
  SET_FILTER: "SET_FILTER",
  SET_FILTER_DEFAULTS: "SET_FILTER_DEFAULTS",
  SET_LOADING: "SET_LOADING",
};
